import { render, staticRenderFns } from "./image_block_with_text.vue?vue&type=template&id=abd38fe2&scoped=true&"
import script from "./image_block_with_text.vue?vue&type=script&lang=js&"
export * from "./image_block_with_text.vue?vue&type=script&lang=js&"
import style0 from "./image_block_with_text.vue?vue&type=style&index=0&id=abd38fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd38fe2",
  null
  
)

export default component.exports